import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CartItems from "./cartItems";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "animate.css";

function ShopCart({ setCart }) {
  const { itemInCart } = useSelector((state) => state.cart);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleWhatsAppOrder = () => {
    if (!itemInCart || itemInCart.length === 0) {
      toast.info("Араба бош. Жеткирүү үчүн буйрутма бергенге чейин өнүмдөрдү кошуңуз.");
      return;
    }

    const phoneNumber = "996559318110";
    let message = "Саламатсызбы, мен төмөнкү товарларды заказ кылгым келет: \n";

    itemInCart.forEach((item) => {
      message += `${item.title}: ${item.subtext} - Баасы: ${item.price} сом.\n`;
    });

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="overlay">
      <div className="cart-container">
        <div className="flex flex-col gap-[2vh]">
          <div className="flex justify-between">
            <button onClick={() => setCart(false)} className="back-button">
              <ion-icon name="arrow-back-outline"></ion-icon>
            </button>
          </div>
          <div className="cart-items">
            {itemInCart && itemInCart.length > 0 ? (
              itemInCart.map((el) => <CartItems key={el.id} item={el} />)
            ) : (
              <p key="empty-cart" className="empty-cart-text">
                Корзина пуста
              </p>
            )}
          </div>
        </div>
        <div className="cart-content border-t border-zinc-300">
          <div className="cart-summary">
            <div className="more-info">
              <div className="total-amount">
                <p className="">Сумма:</p>
                <div className="flex items-center">
                  <p className="">
                    {itemInCart && itemInCart.length > 0
                      ? itemInCart.reduce((total, item) => total + item.price, 0)
                      : 0}
                  </p>
                  <p className=" ml-1">сом</p>
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={handleWhatsAppOrder}
            disabled={!itemInCart || itemInCart.length === 0}
            className={`checkout-btn mt-2 py-2 rounded-md text-sm ${
              (!itemInCart || itemInCart.length === 0) && "disabled"
            }`}
          >
            Заказ берүү үчүн WhatsAppка өтүңүз
          </button>
        </div>
      </div>
    </div>
  );
}

export default ShopCart;
